import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { useNavigate } from 'react-router-dom';
import generateCaptcha from '../../components/captcha';
import { MdNoAdultContent, MdOutlineCottage, MdOutlineInstallMobile } from 'react-icons/md';
import { SiGoogleadsense } from "react-icons/si";
import { PiArrowBendDownRightBold } from "react-icons/pi";
import { FaFacebookSquare, FaLaptopHouse, FaStore } from 'react-icons/fa';
import { BiSolidCricketBall, BiVideoRecording } from 'react-icons/bi';
import { RiHistoryLine } from 'react-icons/ri';
import { BsBrowserChrome } from 'react-icons/bs';
import { DiAndroid } from "react-icons/di";

const Controler = () => {
  const [loader, setLoader] = useState(false);
  const [storyBrand, setStoryBrand] = useState(false);
  const [reels, setReels] = useState(false);
  const [LiveMetch, setLiveMetch] = useState(false);
  const [inHouseAds, setInHouseAds] = useState(false);
  const [facebook_app_id, setFacebook_app_id] = useState('');
  const [facebook_client_token, setFacebook_client_token] = useState('');
  const [afterSplaceAds, setAfterSplaceAds] = useState('OFF');
  const [afterIntroAds, setAfterIntroAds] = useState('OFF');
  const [categoryToVideoList, setCategoryToVideoList] = useState('OFF');
  const [videoListToVideo, setVideoListToVideo] = useState('OFF');
  const [playButton, setPlayButton] = useState('OFF');
  const [storyVideo, setStoryVideo] = useState(false);
  const [storyAdsPosition, setStoryAdsPosition] = useState(1);
  const [ntvTiming, setNtvTiming] = useState(0);
  const [webPosition, setWebPosition] = useState(0);
  const [installNew, setInstallNew] = useState(false);
  const [intentControl, setIntentControl] = useState(false);
  const [videoToVideoPlay, setVideoToVideoPlay] = useState(false);
  const [hidden_module, setHidden_module] = useState(false);
  const [webRedirectUrl, setWebRedirectUrl] = useState(false);
  const [searchText, setSearchText] = useState(false);

  const [installNewData, setInstallNewData] = useState({
    btn_url: "",
  });

  const navigate = useNavigate();

  const options = [
    { value: 'OFF', label: 'OFF' },
    { value: 'OPEN', label: 'OPEN' },
    { value: 'FS', label: 'FULL SCREEN' },
    { value: 'NTV', label: 'NTV' },
    { value: 'URL', label: 'URL' },
    { value: 'FS_WEB', label: 'FS-WEB' },
  ]

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      const resp = await Calling.getControleData();
      const { status, message, data, installNew } = resp;
      if (status) {
        setReels(data?.reels)
        setStoryBrand(data?.storyBrand);
        setStoryAdsPosition(data?.storyAdsPosition);
        setLiveMetch(data?.liveMatch);
        setInHouseAds(data?.inHouseAds);
        setFacebook_app_id(data?.facebook_app_id);
        setFacebook_client_token(data?.facebook_client_token);
        setAfterSplaceAds(data?.afterSplaceAds);
        setAfterIntroAds(data?.afterIntroAds);
        setCategoryToVideoList(data?.categoryToVideoList);
        setVideoListToVideo(data?.videoListToVideo);
        setVideoToVideoPlay(data?.videoToVideoPlay);
        setStoryVideo(data?.storyVideo);
        setNtvTiming(data?.ntvTiming);
        setInstallNewData(installNew);
        setInstallNew(data?.installNew);
        setIntentControl(data?.intentControl);
        setWebPosition(data?.webPosition);
        setHidden_module(data?.hidden_module);
        setWebRedirectUrl(data?.webRedirectUrl);
        setPlayButton(data?.playButton);
        setSearchText(data?.searchText);
      } else {
        toast.error(message);
      }
    } catch (error) {
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  };

  const handleCheckboxChange = async (name, value) => {
    // Display the captcha prompt for confirmation before updating
    const content = `You are about to update. To confirm, please solve this math problem.`;
    const isCaptchaValid = generateCaptcha(content);

    if (!isCaptchaValid) {
      // If the captcha answer is incorrect, show an error message
      return toast.error('Captcha answer is not correct', { autoClose: 2000 });
    }

    setLoader(true); // Set loader to true while processing the request

    try {
      // Call the API to update the control setting
      const resp = await Calling.setControleStoryVideo(name, !value);

      if (resp?.status) {
        toast.success('Updated successfully'); // Show success message on successful update
        if (name == 'exclusive_module') {
          window.location.reload();
        }

      } else {
        // Handle API failure response
        toast.error(resp.message || 'Failed to update');
      }
    } catch (error) {
      // Handle errors in the try block
      console.error(error); // Log the error for debugging
      toast.error('Failed to update');
      navigate('/Error'); // Redirect to the error page
    } finally {
      // Reset the loader and fetch updated data
      setLoader(false);
      fetchData(); // Fetch data to refresh the UI state
    }
  };


  const handleAdsPostion = async (name, value) => {
    if (name === "storyAdsPosition") {
      if (value < 1 || !value) {
        return toast.error('Starting position must be 1 or more');
      } else if (value >= 10) {
        return toast.error('Ending position max 10');
      }
    }
    if (name === "ntvTiming") {
      if (value < 0 || !value) {
        return toast.error('Starting NTV Intend Timer must be 0 or more');
      } else if (value >= 20) {
        return toast.error('Ending NTV Intend Timer max 20');
      }
    }
    const content = `You are about to update story ads position. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Ans is not correct', { autoClose: 2000 });

    setLoader(true);
    try {
      const resp = await Calling.setControleStoryPostion(name, value);
      if (resp.status) toast.success(resp.message);
      else toast.error(resp.message);
    } catch {
      toast.error('Failed to update Ads Position');
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  };

  const handleFacebook = async (e) => {
    e.preventDefault();

    const content = `You are about to update pay amount. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Ans is not correct', { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.setControleFacebook({ facebook_app_id, facebook_client_token });
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Ads Position');
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  }

  const handleAfterSplace = async (field, name) => {
    const content = `You are about to update. To confirm, please solve this math problem.`;
    const isCaptchaValid = generateCaptcha(content);

    if (!isCaptchaValid) {
      return toast.error('Captcha answer is not correct', { autoClose: 2000 });
    }

    setLoader(true);
    try {
      const resp = await Calling.setControllerSetAfterSplace({ field, name });

      if (resp?.status) {
        toast.success('Updated successfully');
      } else {
        toast.error(resp.message || 'Failed to update');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update');
      navigate('/Error');
    } finally {
      setLoader(false);
      fetchData();
    }
  };
  const handleInstallNew = async (e) => {
    e.preventDefault();

    const content = `You are about to update pay amount. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Ans is not correct', { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.installNew(installNewData);
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Ads Position');
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  }

  const handelChangeInsatall = (e) => {
    setInstallNewData({ ...installNewData, [e.target.name]: e.target.value })
  }

  const handleWebUrl = async (field, value) => {
    const content = `You are about to update story ads position. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Ans is not correct', { autoClose: 2000 });

    setLoader(true);
    try {
      const resp = await Calling.setControleWebUrl({ field, url: value });
      if (resp.status) toast.success(resp.message);
      else toast.error(resp.message);
    } catch {
      toast.error('Failed to update Ads Position');
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {
        loader ? (
          <Loader loader={loader} />
        ) : (
          <div className="md:ml-[4.4rem] w-full mt-16 px-3">
            <h1 className="text-2xl font-bold mt-6 text-main-font w-auto">Controller</h1>

            <div className="bg-main-white w-full rounded-xl p-4 mt-2">
              {/* Story Home */}
              <div className="border border-main-border rounded-xl p-4">
                <div className='flex justify-between items-center mb-4'>
                  <h1 className="text-xl font-bold flex items-center gap-3">
                    <MdOutlineCottage size={24} />
                    Home
                  </h1>
                </div>
                <hr className='mt-2 border-main-border' />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                  {/* { label: 'Reels', value: reels, handler: () => handleCheckboxChange('reels', reels), icon: <MdOutlineSlowMotionVideo className="" size={22} /> }, */}
                  {[
                    { label: 'Sortcut', value: storyBrand, handler: () => handleCheckboxChange('storyBrand', storyBrand), icon: <PiArrowBendDownRightBold className="" size={22} /> },
                    { label: 'Story', value: storyVideo, handler: () => handleCheckboxChange('storyVideo', storyVideo), icon: <RiHistoryLine className="" size={20} /> },
                    { label: 'Live Match', value: LiveMetch, handler: () => handleCheckboxChange('liveMatch', LiveMetch), icon: <BiSolidCricketBall className="" size={22} /> },
                    { label: 'X Player', value: hidden_module, handler: () => handleCheckboxChange('hidden_module', hidden_module), icon: <MdNoAdultContent className="" size={22} /> },
                    { label: 'InHouse Ads', value: inHouseAds, handler: () => handleCheckboxChange('inHouseAds', inHouseAds), icon: <FaLaptopHouse className="" size={22} /> },
                  ].map((item, index) => (
                    <div key={index} className="flex items-center justify-between p-6 border border-main-border rounded-2xl">
                      <span className="flex items-center gap-4 text-md text-main-font">{item.icon}{item.label}</span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={item.value}
                          onChange={item.handler}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-main-blue/50 dark:peer-focus:ring-main-blue/80 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-main-white after:border-main-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-main-blue"></div>
                      </label>
                    </div>
                  ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                  <div className="flex flex-col justify-between p-3 sm:p-4 md:p-6 border border-main-border rounded-xl h-full">
                    <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base text-main-font mb-3 flex-shrink-0">
                      <BiVideoRecording size={18} className="sm:text-xl flex-shrink-0" />
                      <span className="truncate pe-2">Story Ad Position </span>
                    </label>
                    <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
                      <input
                        type="number"
                        value={storyAdsPosition}
                        min="1"
                        max="10"
                        onChange={(e) => setStoryAdsPosition(e.target.value)}
                        className="border border-main-border rounded-lg p-2 bg-white text-main-font text-sm sm:text-base focus:ring-2 focus:ring-main-blue w-fulls"
                      />
                      <button
                        onClick={(e) => handleAdsPostion("storyAdsPosition", storyAdsPosition)}
                        className="px-3 sm:px-4 py-2 bg-green-500 text-main-white rounded hover:bg-green-600 w-full text-sm sm:text-bases"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  {/* Native Timing */}
                  <div className="flex flex-col justify-between p-3 sm:p-4 md:p-6 border border-main-border rounded-xl h-full">
                    <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base text-main-font mb-3 flex-shrink-0">
                      <BiVideoRecording size={18} className="sm:text-xl flex-shrink-0" />
                      <span className="truncate pe-2">NTV Intend Timer </span>
                    </label>
                    <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
                      <input
                        type="number"
                        value={ntvTiming}
                        min="1"
                        max="10"
                        onChange={(e) => setNtvTiming(e.target.value)}
                        className="border border-main-border rounded-lg p-2 bg-white text-main-font text-sm sm:text-base focus:ring-2 focus:ring-main-blue w-fulls"
                      />
                      <button
                        onClick={(e) => handleAdsPostion("ntvTiming", ntvTiming)}
                        className="px-3 sm:px-4 py-2 bg-green-500 text-main-white rounded hover:bg-green-600 w-full text-sm sm:text-bases"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              <div className="border border-main-border rounded-xl mt-4 sm:mt-6 p-3 sm:p-4 md:p-6 w-full max-w-full overflow-hidden">
                <div className="flex flex-wrap justify-between items-center mb-3 sm:mb-4">
                  <h1 className="text-lg sm:text-xl md:text-2xl font-bold flex items-center gap-2 sm:gap-3">
                    <FaStore className="flex-shrink-0" size={20} />
                    Ads Management
                  </h1>
                </div>
                {/* Second Section - Ad Types Configuration */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 mt-6">
                  {[
                    {
                      label: 'Ads for Splash & Intro 1, 2, 3',
                      value: afterSplaceAds,
                      handler: (e) => setAfterSplaceAds(e.target.value),
                      options: options,
                      saveHandler: () => handleAfterSplace('afterSplaceAds', afterSplaceAds),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'After Welcome Ads',
                      value: afterIntroAds,
                      handler: (e) => setAfterIntroAds(e.target.value),
                      options: options,
                      saveHandler: () => handleAfterSplace('afterIntroAds', afterIntroAds),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'Category To VideoList',
                      value: categoryToVideoList,
                      handler: (e) => setCategoryToVideoList(e.target.value),
                      options: [...options, { value: 'REWARD', label: 'REWARD' }],
                      saveHandler: () => handleAfterSplace('categoryToVideoList', categoryToVideoList),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'VideoList To Video',
                      value: videoListToVideo,
                      handler: (e) => setVideoListToVideo(e.target.value),
                      options: [...options, { value: 'REWARD', label: 'REWARD' }],
                      saveHandler: () => handleAfterSplace('videoListToVideo', videoListToVideo),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'Video To VideoPlay',
                      value: videoToVideoPlay,
                      handler: (e) => setVideoToVideoPlay(e.target.value),
                      options: [...options, { value: 'REWARD', label: 'REWARD' }],
                      saveHandler: () => handleAfterSplace('videoToVideoPlay', videoToVideoPlay),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'Play Button',
                      value: playButton,
                      handler: (e) => setPlayButton(e.target.value),
                      options: [...options, { value: 'REWARD', label: 'REWARD' }],
                      saveHandler: () => handleAfterSplace('playButton', playButton),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                    {
                      label: 'Intent Control',
                      value: intentControl,
                      handler: (e) => setIntentControl(e.target.value),
                      options: [
                        { value: 'BOTH', label: 'BOTH' },
                        { value: 'FORWORD', label: 'FORWORD' },
                        { value: 'BACKWORD', label: 'BACKWORD' },
                      ],
                      saveHandler: () => handleAfterSplace('intentControl', intentControl),
                      icon: <SiGoogleadsense size={18} className="flex-shrink-0" />,
                    },
                  ].map((item, index) => (
                    <div key={index} className="flex flex-col justify-between p-3 sm:p-4 md:p-6 border border-main-border rounded-xl h-full">
                      <span className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base text-main-font mb-3 flex-shrink-0">
                        {item.icon}
                        <span className="truncate">{item.label}</span>
                      </span>

                      <div className="flex flex-col gap-3 mt-auto">
                        {/* Select Box */}
                        <select
                          className="border border-main-border rounded-lg p-2 bg-white text-main-font text-sm sm:text-base focus:ring-2 focus:ring-main-blue w-full"
                          value={item.value}
                          onChange={item.handler}
                        >
                          {item.options.map((option, idx) => (
                            <option key={idx} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>

                        {/* Save Button */}
                        <button
                          className="px-3 sm:px-4 py-2 bg-green-500 text-main-white rounded hover:bg-green-600 w-full text-sm sm:text-base"
                          onClick={item.saveHandler}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Facebook Pay */}
              <div className="border border-main-border rounded-xl mt-4 sm:mt-6 p-3 sm:p-4 md:p-6 w-full max-w-full overflow-hidden">

                <div className='flex justify-between items-center mb-4'>
                  <h1 className="text-xl font-bold flex items-center gap-3">
                    <FaFacebookSquare />
                    Facebook
                  </h1>
                </div>
                <hr className='mt-2 border-main-border' />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 ">
                  <form onSubmit={handleFacebook} className='col-span-12 space-y-4'>
                    <div className='grid grid-cols-12 items-center'>
                      <label htmlFor="facebook_app_id" className="block text-main-font mb-2 col-span-2">
                        Facebook App ID
                      </label>
                      <input
                        type="text"
                        id="facebook_app_id"
                        name="facebook_app_id"
                        onChange={(e) => setFacebook_app_id(e.target.value)}
                        value={facebook_app_id}
                        className="w-full border border-main-border p-2 rounded-md col-span-10"
                        placeholder='ex. 135885938132XXXX'
                        required
                      />
                    </div>
                    <div className="grid grid-cols-12 items-center">
                      <label htmlFor="facebook_client_token" className="block text-main-font mb-2 col-span-2">
                        Facebook Client Token
                      </label>
                      <input
                        type="text"
                        id="facebook_client_token"
                        name="facebook_client_token"
                        onChange={(e) => setFacebook_client_token(e.target.value)}
                        value={facebook_client_token}
                        className="w-full border border-main-border p-2 rounded-md col-span-10"
                        placeholder='ex. 964343XX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'
                        required
                      />
                    </div>
                    <div className='flex justify-end py-1'>
                      <button
                        type="submit"
                        name='submit'
                        className="bg-main-blue text-main-white px-4 py-2 rounded-md hover:bg-main-blue/80 transition"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* WebUrl */}
              <div className="border border-main-border rounded-xl mt-4 sm:mt-6 p-3 sm:p-4">
                <div className="flex justify-between items-center mb-4">
                  <h1 className="text-xl font-bold flex items-center gap-2">
                    <BsBrowserChrome />
                    Web Redirect URL
                  </h1>
                </div>

                <hr className="border-gray-200 mb-6" />

                {/* URL Input Section */}
                <div className="p-5 border border-gray-200 rounded-xl mb-5">
                  <form onSubmit={(e) => handleWebUrl("webRedirectUrl", webRedirectUrl)} className="space-y-5">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                      <label htmlFor="webRedirectUrl" className="w-full text-black sm:w-1/6">
                        URL
                      </label>
                      <div className="w-full sm:w-5/6">
                        <input
                          type="url"
                          id="webRedirectUrl"
                          name="webRedirectUrl"
                          onChange={(e) => setWebRedirectUrl(e.target.value)}
                          value={webRedirectUrl}
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                          placeholder="https://example.com"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="submit"
                        name="submit"
                        className="bg-main-blue text-main-white px-4 py-2 rounded-md hover:bg-main-blue/80 transition"

                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

                {/* Web Position Section */}
                <div className="p-5 border border-gray-200 rounded-xl">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <label className="flex items-center gap-2 font-medium w-full text-black sm:w-1/6">
                      <BsBrowserChrome className="" />
                      Web Position
                    </label>
                    <div className="flex items-center gap-3 w-full sm:w-5/6">
                      <input
                        type="number"
                        value={webPosition}
                        min="1"
                        max="100"
                        onChange={(e) => setWebPosition(e.target.value)}
                        className="border border-gray-300 rounded-lg p-3 bg-white text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-32"
                      />
                      <button
                        onClick={() => handleAdsPostion("webPosition", webPosition)}
                        className="px-5 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200 font-medium"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* App */}
              <div className="border border-main-border rounded-xl mt-4 sm:mt-6 p-3 sm:p-4">
                <div className="flex justify-between items-center mb-4">
                  <h1 className="text-xl font-bold flex items-center gap-2">
                    <DiAndroid />
                    App
                  </h1>
                </div>

                <hr className="border-gray-200 mb-6" />

                {/* URL Input Section */}
                <div className="p-5 border border-gray-200 rounded-xl mb-5">
                  <form onSubmit={(e) => handleWebUrl("searchText", searchText)} className="space-y-5">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                      <label htmlFor="searchText" className="w-full text-black sm:w-1/6">
                        Search Text
                      </label>
                      <div className="w-full sm:w-5/6">
                        <input
                          type="test"
                          id="searchText"
                          name="searchText"
                          onChange={(e) => setSearchText(e.target.value)}
                          value={searchText}
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                          placeholder="Ex. Type any text here"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="submit"
                        name="submit"
                        className="bg-main-blue text-main-white px-4 py-2 rounded-md hover:bg-main-blue/80 transition"

                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

              </div>

              {/* Install New App */}
              <div className="border border-main-border rounded-xl mt-4 sm:mt-6 p-3 sm:p-4">
                <div className="flex flex-wrap justify-between items-center mb-3 sm:mb-4">
                  <h1 className="text-lg sm:text-xl font-bold flex items-center gap-2 sm:gap-3">
                    <MdOutlineInstallMobile className="flex-shrink-0" size={20} />
                    Install New App
                  </h1>
                  <label className="relative inline-flex items-center cursor-pointer flex-shrink-0 mt-2 sm:mt-0">
                    <input
                      type="checkbox"
                      checked={installNew}
                      onChange={() => handleCheckboxChange('installNew', installNew)}
                      className="sr-only peer"
                    />
                    <div className="relative w-10 sm:w-11 h-5 sm:h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-main-blue/50 dark:peer-focus:ring-main-blue/80 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-main-white after:border-main-border after:border after:rounded-full after:h-4 sm:after:h-5 after:w-4 sm:after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-main-blue"></div>
                  </label>
                </div>

                {installNew && (
                  <>
                    <hr className="mt-4 border-main-border" />
                    <div className="grid grid-cols-1 gap-3 sm:gap-6 mt-4 sm:mt-6">
                      <form onSubmit={handleInstallNew} className="space-y-3 sm:space-y-4">
                        <div className="flex flex-col sm:grid sm:grid-cols-12 sm:items-center gap-2 sm:gap-4">
                          <label htmlFor="btn_url" className="block text-main-font sm:col-span-2 sm:mb-0 mb-1">
                            CTA Url
                          </label>
                          <input
                            type="text"
                            id="btn_url"
                            name="btn_url"
                            onChange={handelChangeInsatall}
                            value={installNewData?.btn_url}
                            className="w-full border border-main-border p-2 rounded-md sm:col-span-10"
                            placeholder="ex. http://mamatamusicbanaras.com/"
                            required
                          />
                        </div>
                        <div className="flex justify-end py-1 mt-2">
                          <button
                            type="submit"
                            name="submit"
                            className="bg-main-blue text-main-white px-4 py-2 rounded-md hover:bg-main-blue/80 transition"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
              </div>

            </div>
          </div>
        )}
    </>
  );
};

export default Controler;
